export default "<p>\r\n  {{'Settings.RestartApplicationToContinue' |translate}}\r\n</p>\r\n"